import { addDays, format, isSameDay } from 'date-fns';
import { formatElapsed } from './elapsed';

export type PlannedEntry = { kind: 'in'; duration: string } | { kind: 'tomorrow' } | { kind: 'on'; date: string };

/** Une entrée déjà passée n'aide plus à prioriser : on ne l'affiche pas. */
export const describePlannedEntry = (entryAt: Date | undefined, now: Date): PlannedEntry | undefined => {
  if (!entryAt || entryAt <= now) {
    return undefined;
  }
  if (isSameDay(entryAt, now)) {
    return { kind: 'in', duration: formatElapsed(now, entryAt) };
  }
  if (isSameDay(entryAt, addDays(now, 1))) {
    return { kind: 'tomorrow' };
  }
  return { kind: 'on', date: format(entryAt, 'dd/MM') };
};
